import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { Representants } from 'src/app/core/entities/representants.model';
import * as _ from 'lodash';
import { Utils } from 'src/app/core/utils/utils';

@Component({
  selector: 'app-dialogs-representant',
  templateUrl: './dialogs-representant.component.html',
  styleUrls: ['./dialogs-representant.component.css']
})
export class DialogsRepresentantComponent implements OnInit {

  $mostrar!: Subscription;

  loading: boolean = true;
  dboid: string = "";

  representant: Representants = new Representants();
  allRepresentants: Representants[] = [];

  optionsRepresentant: SelectItem[] = [];
  optionsRepresentantBase: SelectItem[] = [];

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              @Optional() private dialogRef: MatDialogRef<DialogsRepresentantComponent>) { }

  ngOnInit() {

    this.optionsRepresentantBase.push({ value: null, label: "" });
    this.allRepresentants = _.cloneDeep(this.data.representant);

    this.representant.nomcomplet = _.cloneDeep(this.allRepresentants[0].nomcomplet);
    this.representant.nif = _.cloneDeep(this.allRepresentants[0].nif);

    for (let i = 0; i < this.allRepresentants.length; i++) {
      this.optionsRepresentantBase.push({ value: this.allRepresentants[i].entitatcodi, label: this.allRepresentants[i].entitatnom });
    }

    this.optionsRepresentant = this.optionsRepresentantBase;
    this.optionsRepresentantBase = [];

    this.loading = false;
  }

  /**
  * @description
  * Al pulsar uno de las empresas del representnate mostramos el cif de la entidad y el gargo que desempeña en la empresa
  * @param valor empresa seleccionada en el combo
  */
  valorerPulsado(valor: any){
    this.representant.entitatcif = "";
    this.representant.carrecnom = "";
    for (let i = 0; i < this.allRepresentants.length; i++) {
      if(valor === this.allRepresentants[i].entitatcodi){
        this.representant.entitatcif = _.cloneDeep(this.allRepresentants[i].entitatcif);
        this.representant.carrecnom = _.cloneDeep(this.allRepresentants[i].carrecnom);
      }
    }
  }

  /**
  * @description
  * Cierra el dialog y pasa el codigo de la entidad.
  */
  aceptar() {
    this.dialogRef.close(this.representant.entitatcodi);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar() {
    if (Utils.noUndfAndNull(this.representant.entitatcodi) && this.representant.entitatcodi !== "null") {
        return false;
    } else {
        return true;
    }
  }

}
